import service from '@/utils/request';  //✅ 导入 request.js 中的实例  

 
// 获取用户菜单明细
export const getUserMenu = (url, username, password) => {
  return service.request({
    url: url,
    params: {
      username,
      password
    },
    method: 'post'
  })
}

export const logout = (token) => {
  return service.request({
    url: 'logout',
    method: 'post'
  })
}
 
// 返回加密的字符串
export const getEncodePwd = (password) => {
  return service.request({
    url: 'xuper_auth/encodePwd',
    method: 'post',
    data: {
      password
    }
  })
}
  /**   返回表字段集合或表数据集合：参数1：api请求根目录，参数2：api请求用户，参数3：api请求密码
   *    参数4：api请求视图名，参数5：api请求视图字段名，参数6：api请求视图字段值，
   *    参数7：api请求视图字段名 可为空，参数8：api请求视图字段值 可为空，
   *    参数9：api请求视图字段名 可为空，参数10：api请求视图字段值 可为空，
  **/
  export const getTabColOrData =(v_url, table_,key_,val_,key2_,val2_,key3_,val3_,cond_) =>{
  
    return service.post( v_url, {
      p_key:key_,p_value:val_,p_key2:key2_,p_value2:val2_,p_key3:key3_,p_value3:val3_,p_table:table_,p_cond:cond_
    })
	}  
 
  // 获取表格字段数据
  export const getTab_Column =(v_url, table_,key_,val_,key2_,val2_, cond_,v_lang) =>{
    return service.post(v_url, {
      p_key:key_,p_value:val_,p_key2:key2_,p_value2:val2_, p_table:table_,p_cond:cond_ 
    }).then((res ) => {
       const v_data = (res as any).result
       const v_column = v_data.map((item: any) => ({
          title: v_lang=='CN'?item.title:v_lang=='EN'?item.FLDEN:v_lang=='YN'?item.FLDYN:item.title,
          key: item.key,
          align: item.align,
          width: item.width,   
          edcss: item.EDCSS,  
          thide: item.THIDE,   
          fhide: item.FHIDE,                    
          disabled: item.DISABLED, 
          sortable:item.SORTABLE,
          notnull:item.NOTNULL,
       }) )
       return v_column
    })
	}  
 
  // 返回基础资料 数据：如客户资料、供应商资料、数据字典 到 select options
  export  const getBaseData =(v_url,v_key,v_value,v_key2,v_value2,v_table,v_cond)=> {
    return service.post(v_url, {
        p_key :v_key,
        p_value:v_value,
        p_key2 :v_key2,
        p_value2:v_value2,
        p_table :v_table,
        p_cond:v_cond,
 
    })
	}

     // 使用如下方法可以将json的key值转为大写，小写同理
     export const  upperJSONKey=(json)=> {
      if (json instanceof Array) {
        for (var key in json) {
          upperJSONKey(json[key]);
        }
      } else if (json instanceof Object) {
        for (var key2 in json) {
            // var reg =/^[a-z0-9_]+$/;
         var reg=/[a-z0-9]+$/;
          if (json[key2] instanceof Object || json[key2] instanceof Array) {
             upperJSONKey(json[key2]);
          } else {
            if (reg.test(key2)) {
              var lowerKey = key2.toUpperCase();
              json[lowerKey] = json[key2];
              delete json[key2];
            }
          }
        }
      }
      return json;
    }
    export const lowerJSONKey=(json)=> {
      if (json instanceof Array) {
        for (var key in json) {
          lowerJSONKey(json[key]);
        }
      } else if (json instanceof Object) {
        for (var key2 in json) {
          var reg = /[A-Z0-9]+$/;
          if (json[key2] instanceof Object || json[key2] instanceof Array) {
             lowerJSONKey(json[key2]);
          } else {
            if (reg.test(key2)) {
              var lowerKey = key2.toLowerCase();
              json[lowerKey] = json[key2];
              delete json[key2];
            }
          }
        }
      }
      return json;
    }
    export const isNull=(v_obj)=> {
      if  (v_obj==null || !v_obj){
        return ''
      }else{
        return v_obj;
      }
    }
 